import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-warm py-16 md:py-24" ref={ref} data-id="element-181">
      <div className="max-w-prose mx-auto px-5" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-183">
          {/* Section marker */}
          <p className="font-sans text-xs tracking-[0.15em] uppercase text-sage mb-4" data-id="element-184">
            El momento exacto
          </p>

          <h2 className="font-sans font-bold text-2xl md:text-3xl text-charcoal mb-8 leading-tight" data-id="element-185">
            Hay un instante pequeño, pero brutal.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-serif text-lg md:text-xl leading-[1.85] text-charcoal/90 space-y-6" data-id="element-186">
          <p data-id="element-187">
            Cuando te pones el pantalón y, antes de mirar el espejo, ya sabes.
          </p>

          <p data-id="element-188">
            No es "vanidad". Es el mensaje silencioso que te manda el cuerpo:{' '}
            <strong className="text-charcoal" data-id="element-189">«Hoy tampoco.»</strong>
          </p>

          <p data-id="element-190">Y ahí empieza el ciclo:</p>

          {/* The cycle — styled as a visual list */}
          <div className="bg-cream/80 rounded-xl p-6 md:p-8 border border-gold/20 my-8" data-id="element-191">
            <div className="space-y-3 font-sans text-base md:text-lg text-charcoal/80" data-id="element-192">
              <p className="flex items-start gap-3" data-id="element-193">
                <span className="text-gold mt-1 flex-shrink-0" data-id="element-194">→</span>
                <span data-id="element-195">te restringes,</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-196">
                <span className="text-gold mt-1 flex-shrink-0" data-id="element-197">→</span>
                <span data-id="element-198">aguantas,</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-199">
                <span className="text-gold mt-1 flex-shrink-0" data-id="element-200">→</span>
                <span data-id="element-201">te cansas,</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-202">
                <span className="text-gold mt-1 flex-shrink-0" data-id="element-203">→</span>
                <span data-id="element-204">un día te sales,</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-205">
                <span className="text-terracotta mt-1 flex-shrink-0" data-id="element-206">→</span>
                <span className="text-terracotta font-medium" data-id="element-207">
                  te inflamas,
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-208">
                <span className="text-gold mt-1 flex-shrink-0" data-id="element-209">→</span>
                <span data-id="element-210">te culpas,</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-211">
                <span className="text-gold mt-1 flex-shrink-0" data-id="element-212">→</span>
                <span data-id="element-213">vuelves a empezar.</span>
              </p>
            </div>
          </div>

          <p data-id="element-214">
            No porque seas débil. Sino porque estás intentando resolver{' '}
            <strong data-id="element-215">un problema nuevo con soluciones viejas.</strong>
          </p>
        </motion.div>
      </div>
    </section>;
}